import axios from 'axios'
import isEmpty from 'lodash-es/isEmpty'
import GetCookie from '../globalHeader/common/getCookie'
import { tokenCookieKey } from '../globalHeader/functions/ams-functions'
import { createClientContext } from '../utils/apiContextHelper'
import { getRuntimeEnv } from '../utils/runtimeEnv'

export const getApiUrl = (): string => {
    const runtimeUrl = getRuntimeEnv('VITE_REACT_APP_AMS_URL')
    if (runtimeUrl) return runtimeUrl
    // ts-ignore needed for next.js app
    // @ts-ignore
    if (!isEmpty(import.meta) && import.meta.env.VITE_REACT_APP_AMS_URL) {
        // @ts-ignore
        return import.meta.env.VITE_REACT_APP_AMS_URL
    } else if (process.env.NEXT_PUBLIC_AMS_URL) {
        return process.env.NEXT_PUBLIC_AMS_URL
    } else {
        throw new Error('API URL is not defined')
    }
}

const API_URL = getApiUrl()

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
        'X-Context': JSON.stringify(createClientContext()),
    },
    withCredentials: true,
})

// Add a request interceptor
api.interceptors.request.use(
    async (config) => {
        let token = GetCookie(tokenCookieKey)
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers['X-Context'] = JSON.stringify(createClientContext())
        }

        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

// Add a response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config

        // If the error status is 401 and there is no originalRequest._retry flag,
        // it means the token has expired and we need to refresh it
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true

            try {
                // TODO: need to implement refresh token logic here
                // originalRequest.headers.Authorization = `Bearer ${token}`
                // return axios(originalRequest)
            } catch (error) {
                // Handle refresh token error or redirect to login
            }
        }

        return Promise.reject(error)
    },
)

export default api
